import script from "./ArticlePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlePage.vue?vue&type=script&setup=true&lang=js"

import "./ArticlePage.vue?vue&type=style&index=0&id=5c2126fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2126fc"]])

export default __exports__